import { render, staticRenderFns } from "./InfoDisplay.vue?vue&type=template&id=0c2416be"
import script from "./InfoDisplay.vue?vue&type=script&lang=ts"
export * from "./InfoDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports